import Layout from "../components/Layout/Layout";
import MainForm from "../components/MainForm";
import LoginContainer from "./LoginContainer";
const Main = ({
  data,
  user,
  handleSearch,
  handleChange,
  handleOpenDetail,
  handleOpenItem,
  handleCloseDetail,
  handleCloseItem,
}) => {
  if (user) {
    return (
      <Layout user={user}>
        <MainForm
          data={data}
          user={user}
          handleSearch={handleSearch}
          handleChange={handleChange}
          handleOpenDetail={handleOpenDetail}
          handleOpenItem={handleOpenItem}
          handleCloseDetail={handleCloseDetail}
          handleCloseItem={handleCloseItem}
        />
      </Layout>
    );
  } else {
    return <LoginContainer />;
  }
};
export default Main;
